import React from 'react';

import classNames from 'classnames';
import {shallowEqual, useSelector} from 'react-redux';

import {Navigate} from 'react-router-dom';

import {FeatureWithAnalytics} from 'components/feature';
import {SuccessTimeline} from 'components/success/contacts/successTimeline/successTimeline';

import {VisiblyAlert} from 'components/success/contacts/visiblyAlert/visiblyAlert';
import {PRESCRIPTION_STATUS} from 'constants/success';
import {ApplicationStoreType} from 'desktop/store';
import {getIsAllItemsOfOrderUpdated} from 'libs/success/helpers/helpers';

import {ItemsType} from 'types/successPage';

import {OneTimeCouponOffer} from '../../components/oneTimeCouponOffer/oneTimeCouponOffer';
import {DrawerContainer} from '../../componentsV2/contacts/drawerContainer/drawerContainer';
import {SuccessHeader} from '../../componentsV2/contacts/successHeader/successHeader';
import {OrderDetails} from '../../componentsV2/orderDetails/orderDetails';
import {SuccessRightSide} from '../../componentsV2/successRightSide/successRightSide';

import {getOrderDetails} from '../../selectorsV2';
import {getIsAllContacts, getPrescriptionStatus} from '../../selectorsV2/prescription';

import {getOrderItems} from '../../store/selectors/orderStatus/orderStatus';

import {useListeners} from './useListeners';

import s from './successContacts.scss';

const getIsVisibly = (items: ItemsType) =>
    Boolean(
        items?.find(
            ({prescriptionStatus}) =>
                prescriptionStatus === PRESCRIPTION_STATUS.VISIBLY ||
                prescriptionStatus === PRESCRIPTION_STATUS.EYE_EXAM,
        ),
    );

/**
 * Success contacts typ page
 */
export const SuccessContacts = () => {
    const {
        isOnlyContacts,
        items,
        orderDetails: {
            items: orderItems,
            shipping_address: {email},
            status,
        },
        originalStatus,
    } = useSelector(
        (store: ApplicationStoreType) => ({
            isOnlyContacts: getIsAllContacts(store),
            items: getOrderItems(store),
            orderDetails: getOrderDetails(store),
            orderItems: getOrderDetails(store).items,
            originalStatus: getPrescriptionStatus(store),
        }),
        shallowEqual,
    );

    const isOrderRejected = status === 'REJECTED';

    const isVerification =
        getIsAllItemsOfOrderUpdated(items) || originalStatus === PRESCRIPTION_STATUS.UPLOAD;

    useListeners();

    if (isOrderRejected) {
        return <Navigate to="/checkout/cart" />;
    }

    return (
        <>
            <div className={classNames(s.container, {[s.verification]: isVerification})}>
                <div className={s.leftPart}>
                    <SuccessHeader />
                    {isOnlyContacts && orderItems?.length === 1 && (
                        <SuccessTimeline orderItems={items} originalStatus={originalStatus} />
                    )}
                    <div
                        className={classNames(s.detailsWrapper, {
                            [s.withoutTimeline]:
                                !isOnlyContacts || (isOnlyContacts && orderItems?.length > 1),
                        })}
                    >
                        {getIsVisibly(items) && (
                            <VisiblyAlert email={email} isMixedFrames={!isOnlyContacts} />
                        )}
                        <OrderDetails />
                        <FeatureWithAnalytics
                            flag="dTypOneTimeCoupon"
                            isInteraction={false}
                            platform="desktop"
                        >
                            <OneTimeCouponOffer />
                        </FeatureWithAnalytics>
                    </div>
                </div>
                <div className={s.rightPart}>
                    <SuccessRightSide />
                </div>
            </div>
            <DrawerContainer />
        </>
    );
};
